import { createContext, useContext } from 'react';
import { User } from 'types';

const CurrentUserContext = createContext({} as User);

export default function useCurrentUserContext() {
  return useContext(CurrentUserContext);
}

export { CurrentUserContext };
